export const moduleName = 'dashboardModule';
